const ICON_COLORS = [
  "default",
  "disabled",
  "error-default",
  "highlight-default",
  "hint-default",
  "hint-inverted",
  "information-default",
  "inverted",
  "primary-active",
  "primary-default",
  "primary-hover",
  "subtle",
  "success-default",
  "warning-default",
  "warning-inverted"
];
export {
  ICON_COLORS
};
//# sourceMappingURL=colors.mjs.map
